export default "__VITE_ASSET__CCWcsgtE__"